import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { MaskPipe } from 'ngx-mask';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../../environments/environment';
import { ContactTypeConstants } from '../../../common/constants/contact-type.constants';
import { ContactTypeValue } from '../../../common/enums/contact-type.value.enum';
import { Member } from '../../../shared/interface/member.interface';
import { CommonService } from '../../../shared/services/common.service';
import { CustomValidators } from '../../../shared/Utils/custom-validator';
import { Utils } from '../../../shared/Utils/utils';
import { CountryLevelValidations } from '../../constants/country-level-validations.interface';
import { DateConstants } from '../../constants/date.constants';
import { PersonalInfoFormConstants } from '../../constants/personal-info-form-property.constants';
import { ResponseStatus } from '../../constants/response-status-constants';
import { ValidateDateOfBirth } from '../../directive/validate-dob';
import { MemberTypeEnum } from '../../enums/member-type.enum';
import { PersonalInfoMemberTitle } from '../../enums/personal-info-title.enums';
import { ControlsConfig, PersonalInformation, VerifyAccountResponse } from '../../interface/enrollment';
import { PersonalInfoFormFields } from '../../interface/enrollment/personal-info-form-fields.interface';
import { PersonalInfoConfig } from '../../interface/personal-info-config.interface';
import { PersonalInfoTitleConfig } from '../../interface/personal-info-title.interface';
import { EnrollmentMessageService } from '../../services/enrollment-message.service';
import { EnrollService } from '../../services/enrollment.service';
import { PersonalInfoTitleConfigService } from '../../services/persoanl-info-title-config.service';
import { PersonalInfoConfigService } from '../../services/personal-info-config.service';
import { MessageService } from '../../../shared/services/message.service';
import { ContactPreferenceType } from '../../enums/contact-preference-type.enum';
import { MemeberCommunicationPreferenceValue } from '../../enums/member-communication-preference-value.enum';
import { CheckoutConfigService } from '../../services/checkout-config.service';

/**
 * @description  Used to Save Enroll
 * User Information and Edit User information
 * @date 2018-07-24
 * @export
 * @class GuestPersonalInfoComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'app-guest-personalinfo',
    templateUrl: '../../templates/template1/views/enrollment/guest-personal-info.component.html',
    styleUrls: ['../../templates/template1/themes/default/css/guest-personal-info.component.less']
})

export class GuestPersonalInfoComponent implements OnInit, OnDestroy {
    formSubmitted: boolean;
    mailAlreadyExist: boolean;
    enrollmentInProgress = false;
    guestUser: boolean;
    guestPersonalInfoFormValidated: boolean;
    guestPersonalInformationForm: FormGroup;
    personalInformation: PersonalInformation;
    guestPersonalInfoSubscription: Subscription;
    clearGuestFormSubscription: Subscription;
    verifyEmailAccountInProgess = false;
    isShowLoader = false;
    phoneNumberAlreadyExists: boolean;
    isShowPhoneNumberLoader = false;
    personalInfoFormFields: PersonalInfoFormFields;
    phoneNumberFormat: string;
    contactTypes : any[] =[];
    isLegacyUser = false;
    intialPollCount = 0;
    maxPollCount = environment.longPollCount;
    userInfo: Member;
    guestPersonalInfoFormValid: boolean;
    personalInfoFormValidations: PersonalInfoFormFields;
    externalEmail: boolean;
    externalFboId: String;
    isEmit = false;
    oldPersonalObj: any;
    maxDate: Date;
    phoneRequired:boolean;
    middleNameRequired:boolean;
    dateOfBirthRequired:boolean;
    personalInfoConfig: PersonalInfoConfig;
    personalInfoTitleConfig: PersonalInfoTitleConfig;
    personalInfoMemberTitle = PersonalInfoMemberTitle;

    @Output() guestPersonalInfo = new EventEmitter<any>();
    @Output() guestPersonalInfoFormStatus = new EventEmitter<any>();
    @Output() verifyEmailAccountStatus = new EventEmitter<boolean>();

    @Input() storeInfo;
    @Input() personalInfo: PersonalInformation;
    @Input() retuningGuestUser: Member;
    @Output() emailAlreadyExists = new EventEmitter<boolean>();

    // ViewChild Attrbutes
    @ViewChild('personalInfoFormBtn') personalInfoFormBtn: ElementRef;
    datePickerStartDateAt = new Date();
    checkoutConfig: any;

    constructor(
        private _enrollmentMessageService: EnrollmentMessageService,
        private _formBuilder: FormBuilder,
        private _commonService: CommonService,
        private _maskPipe: MaskPipe,
        private _enrollService: EnrollService,
        private _personalInfoTitleService: PersonalInfoTitleConfigService,
        private _personalInfoConfigService: PersonalInfoConfigService,
        private _messageService: MessageService,
        private _appMessageService: MessageService,
        private _checkoutConfigService : CheckoutConfigService

    ) {
    }

    ngOnInit() {
        this.loadDefaultSettings();
    }

    /**
    * @description it used to load default configuration
    * of the current component based on user
    * @date 2018-07-19
    * @private
    * @memberof GuestPersonalInfoComponent
    */
    private loadDefaultSettings(): void {
        if (this.storeInfo) {
            this.getFormValidationsJSON();
            this.getDates();
            this.personalInfoConfig = this._personalInfoConfigService.getSettings(this.storeInfo.homeIsocodeThree);
         
            this.personalInfoTitleConfig =this._personalInfoTitleService.getSettings(this.storeInfo.homeIsocodeThree);
      
            this.phoneNumberFormat = this._commonService.getPhoneNumberFormatByCountryCode(this.storeInfo.homeIsocodeThree);
            this.checkoutConfig = this._checkoutConfigService.getSettings(this.storeInfo.homeIsocodeThree,null);
            this.getContactTypes();
        } else {
            this.createGuestPersonalInfoForm();
        }
        this.setDefaultPickerDate();
    }

    
    getContactTypes(): void {
        if(!this.checkoutConfig.removeMobileField && !this.checkoutConfig.removePhoneField){
        this.contactTypes = ContactTypeConstants.phoneTypes;
      }else if(this.checkoutConfig.removeMobileField){
        this.contactTypes[0] = ContactTypeConstants.phoneTypes[0];
      }else if (this.checkoutConfig.removePhoneField){
        this.contactTypes[0] = ContactTypeConstants.phoneTypes[1];
      }
  }

    getFormValidationsJSON(): void {
        this._commonService.getFormValidationsJSON()
          .subscribe((response: any) => {
            this.getCountrySpecificValidations(response);
          }, error => {
            this.createGuestPersonalInfoForm();
          });
      }

      getDates(): void {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();
        const date = currentDate.getDate();
        this.maxDate = new Date(year, month, date);
      }

      getCountrySpecificValidations(validations): void {
        if (validations) {
          const filterCountryLevlValidations = validations
            .find(x => x.countryCode.toUpperCase() === this.storeInfo.homeIsocodeThree.toUpperCase());
          if (filterCountryLevlValidations) {
            this.personalInfoFormValidations = filterCountryLevlValidations.validations;
          }
        }
        this.createGuestPersonalInfoForm();
      }

    /**
     * @description creating a form for
     * user information
     * @date 2018-07-19
     * @memberof GuestPersonalInfoComponent
     */
    private createGuestPersonalInfoForm(): void {
        this.guestPersonalInformationForm = this._formBuilder.group(
            this.addFieldsBasedOnRetailOrGuest()
        );
        this.subscribeGuestPersonalInfoFormChanges();
        this.guestPersonalInfoSubject();
        this.rebindGuestPersonalInformation();

    }

    /**
     * @description this metod is used
     *  to rebind personal information from local storage
     * @date 2018-07-21
     * @private
     * @memberof GuestPersonalInfoComponent
     */
    private rebindGuestPersonalInformation(): void {
        if (this.personalInfo) {
            this.personalInformation = this.personalInfo;
            if (this.personalInformation.phoneNumber) {
                if(this.phoneNumberFormat){
                  this.personalInformation.phoneNumber = this._maskPipe.transform(this.personalInformation.phoneNumber, this.phoneNumberFormat);
                }else{
                  this.personalInformation.phoneNumber =this.personalInformation.phoneNumber
                }
            }
            this.guestPersonalInformationForm.patchValue({
                firstName: this.personalInformation.firstName,
                middleName: this.personalInformation.middleName,
                lastName: this.personalInformation.lastName,
                email: this.personalInformation.email,
                phoneNumber: this.personalInformation.phoneNumber,
                phoneType: this.personalInformation.phoneType
            });
            if (this.personalInfoConfig && this.personalInfoConfig.diaplayDateOfBirth) {
                let dateOfBirthValue = null;
                if (this.personalInformation && this.personalInformation.dateOfBirth) {
                    dateOfBirthValue = moment(new Date(this.personalInformation.dateOfBirth))
                        .format(DateConstants.DateFormat);
                }
                this.guestPersonalInformationForm.patchValue({
                    dateOfBirth: dateOfBirthValue ? moment(dateOfBirthValue, 'DD-MMM-YYYY') : ''
                });
            }        
            if(this.personalInfoConfig && this.personalInfoConfig.displayTitle){
                let title=null;
                if (this.personalInformation && this.personalInformation.title) {
                    title = this.personalInformation.title;  
                    this.guestPersonalInformationForm.patchValue({title});              
                }     
            }
            this.userInfo = this.retuningGuestUser;
            this.mailAlreadyExist = this.personalInformation.mailAlreadyExist;
        }
    }

    /**
     * @description this method used
     * subscribe changes of form submit
     * event
     * @date 2018-07-24
     * @private
     * @memberof GuestPersonalInfoComponent
     */
    private guestPersonalInfoSubject(): void {
        this.guestPersonalInfoSubscription = this
            ._enrollmentMessageService.getSubmitGuestForm().subscribe(isSubmit => {
                this.submitGuestPersonalInfo();
            });
        this.clearGuestFormSubscription = this
            ._enrollmentMessageService.getClearGuestForm().subscribe(isSubmit => {
                this.guestPersonalInformationForm.reset();
            });
    }


    /**
     * this function allows to add controle to
     * peersonal information form based on retail or guest
     * @description
     * @date 2018-07-19
     * @returns {ControlsConfig}
     * @memberof GuestPersonalInfoComponent
     */
    private addFieldsBasedOnRetailOrGuest(): ControlsConfig {
        const formControls: ControlsConfig = {
            firstName: ['', [Validators.required,Utils.noEmptyString]],
            lastName: ['', [Validators.required,Utils.noEmptyString]],
            middleName: ['', [Utils.noEmptyString]],
            email: ['', this.getValidations(PersonalInfoFormConstants.EMAIL)],
            phoneNumber: ['', this.addValidationsForForm()],
            phoneType: this.personalInfoTitleConfig.useContactTypeAsPhone ? [ContactTypeValue.PHONE] : [ContactTypeValue.MOBILE],
        };
        if(this.personalInfoFormValidations && this.personalInfoFormValidations[PersonalInfoFormConstants.MIDDLENAME]){
            const formControlName = this.personalInfoFormValidations? this.personalInfoFormValidations[PersonalInfoFormConstants.MIDDLENAME]:{};
            if(formControlName && formControlName.required){
                const requiredMemberType = formControlName.requiredMemberType ? JSON.parse(formControlName.requiredMemberType) : null;
                if (requiredMemberType && requiredMemberType.length > 0) {
                    if (requiredMemberType.includes(MemberTypeEnum.GUEST)){
                        formControls['middleName'] = ['', [Validators.required, Utils.noEmptyString]];
                        this.middleNameRequired = true;
                    }
                } else {
                    formControls['middleName'] = ['', [Validators.required, Utils.noEmptyString]];
                    this.middleNameRequired = true;
                } 
            }

        } 
        if(this.personalInfoConfig && this.personalInfoConfig.diaplayDateOfBirth){
            formControls['dateOfBirth'] = ['', [ValidateDateOfBirth.DOBFormatValidation]];
        }
        if(this.personalInfoConfig && this.personalInfoConfig.displayTitle){
            formControls['title'] = [PersonalInfoMemberTitle.MR,[Validators.required]];

        }
        return formControls;
    }

    /**
     * @description
     * @date 2020-05-07
     * @memberof GuestPersonalInfoComponent
     */
    addValidationsForForm() {
        const fieldValidations = [];
        const formControlName = this.personalInfoFormValidations
            ? this.personalInfoFormValidations[PersonalInfoFormConstants.PHONENUMBER]
            : {};
        if (formControlName) {
            if (formControlName[PersonalInfoFormConstants.MINLENGTH]) {
                fieldValidations.push(Validators.minLength(formControlName[PersonalInfoFormConstants.MINLENGTH]));
            }
            if (formControlName[PersonalInfoFormConstants.MAXLENGTH]) {
                fieldValidations.push(Validators.maxLength(formControlName[PersonalInfoFormConstants.MAXLENGTH]));
            }
            if (formControlName[PersonalInfoFormConstants.PATTERN]) {
                fieldValidations.push(Validators.pattern(formControlName[PersonalInfoFormConstants.PATTERN]));
            }
            // const formControlName = this.personalInfoFormValidations? this.personalInfoFormValidations[PersonalInfoFormConstants.MIDDLENAME]:{};
            if(formControlName && formControlName.required){
                fieldValidations.push(Validators.required);
                this.phoneRequired = true;
            }
        }
        return fieldValidations;
    }

    /**
     * @description this method will subscribe
     * the changes for form
     * @date 2019-09-09
     * @private
     * @memberof GuestPersonalInfoComponent
     */
    private subscribeGuestPersonalInfoFormChanges(): void {
        this.guestPersonalInformationForm
            .valueChanges.
            subscribe(form => {
                if (this.guestPersonalInfoFormValidated) {
                    this.guestPersonalInfoFormValidated = false;
                }
            });
        this.guestPersonalInformationForm
            .statusChanges.
            subscribe(formStatus => {
                this.guestPersonalInfoFormValid = formStatus === 'INVALID' ? false : true;
               // this.guestPersonalInfoFormStatus.emit(this);
            });
    }

    /**
     * @description validates personal information for usa and canada
     * @param fieldName
     */
    private getValidations(fieldName: string): any[] {
        this.personalInfoFormFields = this.personalInfoFormValidations ? this.personalInfoFormValidations
            : CountryLevelValidations.validations;
        const fieldValidations = [];
        const formControlName = this.personalInfoFormFields ? this.personalInfoFormFields[fieldName] : {};
        if (formControlName) {
            if (formControlName[PersonalInfoFormConstants.MINLENGTH]) {
                fieldValidations.push(Validators.minLength(formControlName[PersonalInfoFormConstants.MINLENGTH]));
            }
            if (formControlName[PersonalInfoFormConstants.MAXLENGTH]) {
                fieldValidations.push(Validators.maxLength(formControlName[PersonalInfoFormConstants.MAXLENGTH]));
            }
            if (formControlName[PersonalInfoFormConstants.PATTERN]) {
                fieldValidations.push(Validators.pattern(formControlName[PersonalInfoFormConstants.PATTERN]));
            }
        }

        // regular expression which allows only latin characterset including accent marks
        // tslint:disable-next-line:quotemark
        // const nameReg = "^[a-zA-Z0-9~`\\!@#\\$%\\^&*\\(\\)_\\+\\-\\=\\{\\}\\|\"\\:<>\\?,/\\\\.\\[\\];'\\s]*$";
        // if (fieldName === PersonalInfoFormConstants.MIDDLENAME || fieldName === PersonalInfoFormConstants.FIRSTNAME
        //     || fieldName === PersonalInfoFormConstants.LASTNAME || fieldName === PersonalInfoFormConstants.EMAIL) {
        //     fieldValidations.push(Validators.pattern(nameReg));
        // }
        if (fieldName === PersonalInfoFormConstants.FIRSTNAME || fieldName === PersonalInfoFormConstants.LASTNAME
            || fieldName === PersonalInfoFormConstants.EMAIL || fieldName === PersonalInfoFormConstants.PHONENUMBER) {
            fieldValidations.push(Validators.required);
            fieldValidations.push(CustomValidators.requiredNotEmpty);
        }
        return fieldValidations;
    }


    /**
     * validates emailId
     * @param  {any} emailId
     * @param  {boolean} isValid
     * @returns void
     */
    verifyEmailAccountExists(emailId: string, isValid: boolean): void {
        if (isValid) {
            this.emitVerifyEmailAccountStatus(true);
            this.userInfo = null;
            this.isShowLoader = true;
            this._enrollService.verifyEmailAccountExists(emailId)
                .subscribe((verifyAccountResponse: VerifyAccountResponse) => {
                    if(!verifyAccountResponse || (verifyAccountResponse && !verifyAccountResponse.isSuccess)){
                        this.mailAlreadyExist = false;
                        this.isShowLoader = false;
                        this.guestUser = false;
                        this.enrollmentInProgress = false;
                        this.userInfo = null;
                        this.emitVerifyEmailAccountStatus(false);
                        return;
                    }
                    if (verifyAccountResponse.requestStatus === ResponseStatus.COMPLETED
                        || !verifyAccountResponse.requestStatus) {
                        this.isShowLoader = false;
                        this.processVerifyEmailAccountExists(verifyAccountResponse);
                    } else if (verifyAccountResponse.requestStatus === ResponseStatus.QUEUED ||
                        verifyAccountResponse.requestStatus === ResponseStatus.IN_PROGRESS) {
                        this.processEmailCheckPoll(verifyAccountResponse);
                    }
                }, (err: any) => {
                    this.mailAlreadyExist = false;
                    this.guestUser = false;
                    this.enrollmentInProgress = false;
                    this.isShowLoader = false;
                    this.userInfo = null;
                    this.emitVerifyEmailAccountStatus(false);
                });
        }
    }

    /**
     * @description this method will emit the
     * status of verify account email exists or not
     * @date 2018-08-27
     * @memberof GuestPersonalInfoComponent
     */
    emitVerifyEmailAccountStatus(verifyAccountInProgess: boolean): void {
        this.verifyEmailAccountInProgess = verifyAccountInProgess;
        this.emailAlreadyExists.emit(this.mailAlreadyExist);
     //   this.verifyEmailAccountStatus.emit(this.verifyEmailAccountInProgess);
    }

    /**
     * @description this method process
     * response of VerifyEmailAccountExists Method
     * @date 2018-07-19
     * @memberof GuestPersonalInfoComponent
     */
    private processVerifyEmailAccountExists(verifyAccountResponse: VerifyAccountResponse): void {
        this.isLegacyUser = false;
        if (verifyAccountResponse) {
            if (!verifyAccountResponse.distributorId && verifyAccountResponse.memberId) {
                this.mailAlreadyExist = false;
                this.enrollmentInProgress = true;
                if(verifyAccountResponse.memberTypeId === MemberTypeEnum.GUEST) {
                 this.guestUser = true;
                }
                else{
                    this.guestUser = false;
                }
                this.userInfo = null;
             } 
             else if (verifyAccountResponse.memberTypeId === MemberTypeEnum.GUEST && verifyAccountResponse.external) {
                this.mailAlreadyExist = false;
                this.guestUser = true;
                this.enrollmentInProgress = false;
                this.externalEmail = true;
                this.externalFboId = verifyAccountResponse.distributorId;
            }
            else if (verifyAccountResponse.memberTypeId === MemberTypeEnum.GUEST) {
                this.mailAlreadyExist = false;
                this.enrollmentInProgress = false;
                this.guestUser = true;
                this.userInfo = this._enrollService.mapAccountResponseToUserInfo(verifyAccountResponse);
            } else if (verifyAccountResponse.distributorId && !verifyAccountResponse.memberId) {
                this.mailAlreadyExist = true;
                this.enrollmentInProgress = false;
                this.guestUser = false;
                this.isLegacyUser = true;
                this.userInfo = null;
            } else {
                this.userInfo = null;
                this.mailAlreadyExist = true;
                this.enrollmentInProgress = false;
                this.guestUser = false;
            }
            this.emitVerifyEmailAccountStatus(false);
            if (verifyAccountResponse.memberPreferences && verifyAccountResponse.memberPreferences.length) {
                verifyAccountResponse.memberPreferences.forEach((element) => {
                    if (element && element.preferenceId && element.preferenceId === ContactPreferenceType.Email) {
                        const privacyPreference = element.preferenceValue === MemeberCommunicationPreferenceValue.YES + '' ? false : true;
                        this._appMessageService.setExistingPrivacyPreference(privacyPreference);
                    };
                });
            }

        } else {
            this.userInfo = null;
            this.mailAlreadyExist = false;
            this.enrollmentInProgress = false;
            this.guestUser = false;
            this.emitVerifyEmailAccountStatus(false);
        }
    }

    /**
     * @description this method will subscribe changes
     * when we need to submit guest info
     * @date 2018-07-24
     * @memberof GuestPersonalInfoComponent
     */
    submitGuestPersonalInfo(): void {
        // submiting personal information
        if (this.personalInfoFormBtn
            && !this.guestPersonalInfoFormValidated) {
            this.personalInfoFormBtn.nativeElement.click();
        }
    }

    /**
     * save personal info for user
     * @param  {any} personalInfoForm
     * @param  {boolean} isValid
     * @returns void
     */
    saveGuestPersonalInfo(personalInformation: PersonalInformation, isValid: boolean): void {
        this.formSubmitted = true;
        personalInformation = this._commonService.trimObjectValues(personalInformation);
        if (this.formSubmitted && isValid
            && !this.mailAlreadyExist && !this.isShowLoader) {
            this.personalInformation = personalInformation;
            this.personalInformation.externalEmail = this.externalEmail ? this.externalEmail : this.personalInfo && this.personalInfo.externalEmail ? this.personalInfo.externalEmail : this.externalEmail;
            this.personalInformation.externalFboId = this.externalFboId ? this.externalFboId  : this.personalInfo && this.personalInfo.externalFboId ? this.personalInfo.externalFboId : this.externalFboId;
            this.guestPersonalInfoFormValidated = true;
            this.removePhoneFormat();
        } else {
            this.guestPersonalInfoFormValidated = false;
            personalInformation.mailAlreadyExist = this.mailAlreadyExist;
            this.personalInformation = personalInformation;
        }
        // emit component information to parent
        this.guestPersonalInfo.emit(this);
    }

    /**
     * @description remove phone format
     * @date 2019-09-09
     * @memberof GuestPersonalInfoComponent
     */
    private removePhoneFormat(): void {
        if (this.personalInformation.phoneNumber) {
            this.personalInformation.phoneNumber = this.personalInformation.phoneNumber.replace(/[^a-zA-Z0-9]/g, '');
        } else {
            this.personalInformation.phoneNumber = null;
        }
    }

    /**
    * validates emailId
    * @param  {any} emailId
    * @param  {boolean} isValid
    * @returns void
    */
    verifyPhoneNumberAccountExists(phoneNumber: string, isValid: boolean): void {
        if (isValid) {
            this.userInfo = null;
            this.isShowPhoneNumberLoader = true;
            this._enrollService.verifyPhoneNumberAccountExists(phoneNumber)
                .subscribe((verifyAccountResponse: boolean) => {
                    this.isShowPhoneNumberLoader = false;
                    this.phoneNumberAlreadyExists = verifyAccountResponse;
                }, (err: any) => {
                    this.isShowPhoneNumberLoader = false;
                    this.phoneNumberAlreadyExists = false;
                });
        }
    }

    /**
     * @description
     * @date 2018-09-17
     * @memberof PersonalInfoComponent
     */
    processEmailCheckPoll(verifyAccountResponse: VerifyAccountResponse) {
        if (this.intialPollCount < this.maxPollCount) {
            this._enrollService.processPollRequest(verifyAccountResponse.location)
                .subscribe(responseObj => {
                    if (responseObj.requestStatus === ResponseStatus.COMPLETED) {
                        this.isShowLoader = false;
                        this.processVerifyEmailAccountExists(responseObj);
                    } else {
                        this.processEmailCheckPoll(responseObj);
                    }
                }, errorResponse => {
                    this._appMessageService.setExistingPrivacyPreference(true);
                    this.mailAlreadyExist = false;
                    this.isShowLoader = false;
                    this.guestUser = false;
                    this.enrollmentInProgress = false;
                    this.emitVerifyEmailAccountStatus(false);
                });
        }
    }
    onFocusOut() {
        if (this.guestPersonalInformationForm.valid) {
            if ((!this.oldPersonalObj) || ((this.isEmit && this.oldPersonalObj) &&
                this.guestPersonalInformationForm.controls['firstName'].value !==   this.oldPersonalObj.firstName ||
                this.guestPersonalInformationForm.controls['lastName'].value !==   this.oldPersonalObj.lastName
                || this.guestPersonalInformationForm.controls['middleName'].value !==   this.oldPersonalObj.middleName )){
                this.guestPersonalInfoFormStatus.emit(this.guestPersonalInformationForm.value);
                this.oldPersonalObj = this.guestPersonalInformationForm.value;
                this.isEmit = true;
            } else {
                this.isEmit = false;
            }
    }
}
    onChange() {
            if (this.guestPersonalInformationForm.valid) {
                if (this.isEmit && this.guestPersonalInformationForm.controls['firstName'].value !== this.oldPersonalObj.firstName ||
                this.guestPersonalInformationForm.controls['lastName'].value !==   this.oldPersonalObj.lastName ||
                this.guestPersonalInformationForm.controls['middleName'].value !==   this.oldPersonalObj.middleName) {
                    this.guestPersonalInfoFormStatus.emit(this.guestPersonalInformationForm.value);
                    this.oldPersonalObj = this.guestPersonalInformationForm.value;
                    this.isEmit = true;
                } else {
                    this.isEmit = false;
                }
            }
    }
    setDefaultPickerDate(): void {
        const startDate = this.datePickerStartDateAt
            .setFullYear(new Date().getFullYear() - 18);
    }
    convertToSpecificDateFormat(dateMomentObj: any) {
        const characterCheck = /[a-zA-z]/;
        const dateInputPattern = /^[a-zA-Z0-9\-]*$/;
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj._i === 'object') {
            dateMomentObj = dateMomentObj._d;
            this.guestPersonalInformationForm.patchValue({
                dateOfBirth: moment(dateMomentObj, 'DD-MMM-YYYY')
            });
        }
        if (dateMomentObj && dateMomentObj.value && typeof dateMomentObj.value._i === DateConstants.String) {
            dateMomentObj = dateMomentObj.value._i;
            if (dateInputPattern.test(dateMomentObj)) {
                const dateParts = dateMomentObj.split('-');
                if (characterCheck.test(dateParts[1])) {
                    dateMomentObj = moment(dateMomentObj, DateConstants.DateFormat);
                } else {
                    dateMomentObj = moment(new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]))
                        .format(DateConstants.DateFormat);
                }
                this.guestPersonalInformationForm.patchValue({
                    dateOfBirth: moment(dateMomentObj, DateConstants.DateFormat)
                });
                this.datePickerStartDateAt = new Date(dateMomentObj);
            } else {
                this.datePickerStartDateAt = new Date() ;
            }
        }

    }

    ngOnDestroy(): void {
        if (this.guestPersonalInfoSubscription) {
            this.guestPersonalInfoSubscription.unsubscribe();
        }
        if (this.clearGuestFormSubscription) {
            this.clearGuestFormSubscription.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/enrollment/guest-personalinfo.component.ts